import anime from "animejs";
import getTouchDevice from "@utils/getTouchDevice";

function createElementFromHTML(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

const dedHtml = `
    <div id="ded" class="ded-animation">
        <img src="/assets/blueant/assets/img/new-year-anim/ded.png"/>
        <svg width="1917" height="781" viewBox="0 0 1917 781" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-3.5 3C358.002 673.371 755.5 762 1916.5 776.5" stroke="#E00613" stroke-width="9"/></svg>
    </div>
`

const dedRootEl = document.querySelector('.d-index#home-app')
dedRootEl.appendChild(createElementFromHTML(dedHtml))

const $ded = $('#ded img')
const $dedPathSvg = anime.path('#ded path');

anime({
    targets: '#ded img',
    // translateX: -window.innerWidth,
    translateX: $dedPathSvg('x'),
    translateY: $dedPathSvg('y'),
    duration: 5400,
    easing: 'linear',
    // loop: true,
    delay: 1000,
    begin: function(anim) {
        initCanvas();
    },
    update: function(anim) {
        const {top, left} = $ded.offset()
        const x = left + $ded.width() - 340
        const y = top + $ded.height() / 2 - 55
        // console.log(Math.ceil(x), Math.ceil(y))
        window.dedAnimation.onUpdateTargetPosition(x, y)
    }
});


const randInRange = (min, max) => Math.random() * (max - min) + min;
const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));

const imgUrl = '/assets/blueant/assets/img/new-year-anim/1.png'

const options = {
    tailLen: 10,

    delay: 30,
    awaySpeed: 0.5,
    moveTail: true,
    tailWidth: 50,
    maxCount: 65
};

const sizesImagesAnimation = {
    1: [55, 116],
    2: [55, 115],
    3: [55, 117],
    4: [54, 114],
    5: [56, 121],
    6: [55, 88],
    7: [119, 126],
    8: [133, 126],
    9: [129, 103],
    10: [115, 139],
    11: [101, 131],
    12: [145, 121],
    13: [126, 82],
    14: [152, 146],
    15: [114, 135],
    16: [168, 155],
    17: [106, 90],
    18: [102, 116],
    19: [128, 116],
}

const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

class dedAnimation {
    constructor() {
        this.canvas = document.createElement("canvas");
        // this.canvas.style.position = "fixed";
        this.canvas.style.position = "absolute";
        this.canvas.style.top = "0";
        this.canvas.style.left = "0";
        this.canvas.style.pointerEvents = "none";
        this.canvas.style.zIndex = "9999999999";

        document.body.appendChild(this.canvas);
        this.canvasContainer = this.canvas.parentElement;
        this.ctx = this.canvas.getContext("2d");
        this.dpr = window.devicePixelRatio || 1;
        this.bubbles = [];
        this.canvasSize = {
            w: 0,
            h: 0
        };

        this.lastSpawnTime = 0;
        this.lastX = 0;
        this.lastY = 0;
        this.dx = 0;
        this.dy = 0;
        this.canvasImage = null;

        this.isDesktop = window.matchMedia('(min-width: 1280px)').matches;
        this.resizeCanvas = this.resizeCanvas.bind(this);
        this.animate = this.animate.bind(this);
        this.initImage = this.initImage.bind(this);
        this.init();
    }

    init() {
        this.initImage();
        this.resizeCanvas();
    }

    setImage(callback = null) {
        this.canvasImage = null;
        const image = new Image(55, 116);
        if (callback) {
            image.onload = () => {
                callback.call(this, image);
            };
        }
        image.src = imgUrl;
    }

    initImage() {
        this.setImage((image) => {
            this.canvasImage = image;
            this.animate();
            window.addEventListener("resize", this.resizeCanvas);
        });
    }

    resizeCanvas() {
        this.canvasSize.w = this.canvasContainer.scrollWidth;
        // this.canvasSize.h = this.canvasContainer.scrollHeight;
        this.canvasSize.h = window.innerHeight;
        this.canvas.width = this.canvasSize.w * this.dpr;
        this.canvas.height = this.canvasSize.h * this.dpr;
        this.canvas.style.width = this.canvasSize.w + "px";
        this.canvas.style.height = window.innerHeight + "px";
        this.ctx.scale(this.dpr, this.dpr);
    }

    onUpdateTargetPosition(x, y) {
        const currentTime = Date.now();
        if (currentTime - this.lastSpawnTime >= options["delay"]) {

            this.dx = x - this.lastX;
            this.dy = y - this.lastY;

            this.createBubble(x, y, this.dx, this.dy);

            this.lastSpawnTime = currentTime;
            this.lastX = x;
            this.lastY = y;
        }
    }


    getRandomImage() {
        const imagesCount = Object.values(sizesImagesAnimation).length
        const num = getRandomInt(1, imagesCount)
        const url = `/assets/blueant/assets/img/new-year-anim/${num}.png`

        const size = sizesImagesAnimation[num]
        const image = new Image(size[0], size[1]);
        image.src = url;
        return image
    }

    createBubble(x, y, dx, dy, moveUp = false) {
        const bubble = new Particle(x, y, dx, dy, this.getRandomImage(), moveUp);
        this.bubbles.push(bubble);
        if (this.bubbles.length > options.maxCount) this.bubbles.shift();
    }

    clearContext() {
        this.ctx.clearRect(0, 0, this.canvasSize.w, this.canvasSize.h);
    }

    animate() {
        this.clearContext();
        for (let i = 0; i < this.bubbles.length; i++) {
            this.bubbles[i].draw(this.ctx, getRandomInt(1, 20));
            if (!this.bubbles[i].update()) this.bubbles.splice(i, 1);
        }
        window.requestAnimationFrame(this.animate);
    }
}

class Particle {
    constructor(x, y, dx, dy, canvasImage, moveUp = false) {
        const randomAngle =
            Math.atan2(dy, dx) +
            Math.PI +
            (randInRange(-options["tailWidth"], options["tailWidth"]) * Math.PI) / 180;

        const randomSize = Math.floor(randInRange(10, 40));
        const shrinkStep = options["awaySpeed"];
        const steps = Math.ceil(randomSize / shrinkStep);

        this.img = canvasImage;
        this.lastSize = 1;
        this.size = 1;
        this.fixedSize = Math.floor(randInRange(10, 40));
        this.x = x - 0.5;
        this.y = y - 0.5;
        this.reachedSize = false;
        this.opacity = 1;
        this.opacityStep = parseFloat((1 / steps).toFixed(4));
        this.shrinkStep = options["awaySpeed"];
        this.dx = Math.cos(randomAngle) * options["tailLen"];
        this.dy = Math.sin(randomAngle) * options["tailLen"];
        this.moveUp = moveUp;
        this.speedUp = false;
        this.canvasImage = canvasImage;

        return this;
    }

    remove() {
        this.speedUp = true;
    }

    drawImage(ctx, img, x, y, angle = 0, scale = 1){
        ctx.save();
        ctx.translate(x + img.width * scale / 2, y + img.height * scale / 2);
        ctx.rotate(angle);
        ctx.translate(- x - img.width * scale / 2, - y - img.height * scale / 2);
        ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
        ctx.restore();
    }

    draw(ctx, rotateAngle = 0) {
        ctx.globalAlpha = clamp(this.opacity, 0, 1);
        this.drawImage(ctx, this.img, this.x, this.y, 0, 0.5);
    }

    update() {
        this.lastSize = this.size;
        this.size = this.reachedSize
            ? this.size - (this.speedUp ? 2 : this.shrinkStep)
            : this.size + 1;
        if (this.reachedSize)
            this.opacity = parseFloat(this.opacity - this.opacityStep).toFixed(4);
        if (this.size <= 0.5 || this.opacity <= 0) return false;

        if (!this.reachedSize && this.size >= this.fixedSize) this.reachedSize = true;

        if (this.moveUp || options["moveTail"] === true) {
            this.x = this.x + this.lastSize / 2 + this.dx - this.size / 2;
            this.y = this.y + this.lastSize / 2 + this.dy - this.size / 2;
        } else {
            this.x = this.x + this.lastSize / 2 - this.size / 2;
            this.y = this.y + this.lastSize / 2 - this.size / 2;
        }

        return true;
    }
}

const initCanvas = () => {
    window.dedAnimation = new dedAnimation();
};